import { instance4 } from "App/constants";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { strReplace } from "../../../PerbekalanFarmasi/InventoryControl/DaftarStockOpname/helpers";
import fileDownload from "js-file-download";

export const urlGet = LIST_URL_WAREHOUSE.daftarStokOpnameLGS.get;
export const urlDelete = LIST_URL_WAREHOUSE.daftarStokOpnameLGS.delete;
export const urlDownload = LIST_URL_WAREHOUSE.daftarStokOpnameLGS.download;

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  gudang: "Pilih Gudang",
  gudang_id: "",
};

export const deleteStockOpnameById = async (id) => {
  try {
    const api = await instance4.post(urlDelete, {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus stock opname",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const getByFilterStockOpname = async (formFilter, pages, limit) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      id: formFilter.id,
      gudang_id: formFilter.gudang_id,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID STOCK OPNAME",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaGudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const downloadStockOpnameLogistikById = async (id, fileName) => {
  try {
    const api = await instance4.get(`${urlDownload}/${id}`, {
      responseType: "blob",
    })
    const res = api.data;
    const filename = strReplace(fileName);

    fileDownload(res, filename + ".xlsx");

    return {
      state: true,
      message: 'Berhasil mendownload stock opname',
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};